import { ComponentRegistry } from './component-registry';
import { Constructor } from '../types/constructor.type';
import { BaseComponent } from './base.component';

export abstract class Module {
  private modules: Module[] = [];

  constructor(
    protected options?: {
      declarations?: Constructor<BaseComponent<any>>[];
      modules?: Constructor<Module>[];
    }
  ) {}

  async register() {
    await this.registerModules();
    this.registerComponents();

    await this.onInit();
  }

  async registerModules() {
    const modules = await Promise.all(
      this.options?.modules
        ?.map((m) => new m())
        .map(async (m) => {
          await m.register();
          return m;
        }) ?? []
    );

    this.modules.push(...modules);
  }

  registerComponents() {
    this.options?.declarations?.forEach((component) =>
      ComponentRegistry.declare(component)
    );
  }

  abstract onInit(): Promise<void>;
}
